import {
    Component,
    EventEmitter,
    OnInit,
    Output,
    Input,
    ChangeDetectorRef,
    QueryList,
    ViewChildren,
} from '@angular/core';
import {
    FormArray,
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import {
    City,
    Country,
    Currency,
    PayerDetails,
    Regulator,
    State,
} from 'src/app/core/Models/interfaces/responseData';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { CustomValidation } from 'src/app/shared/validators/customValidators';
import { ProvPayerApiService } from '../../services/prov-payer-api.service';
import { ProvPayerService } from '../../services/prov-payer.service';
import { DatePipe } from '@angular/common';
import { PhoneCode } from 'src/app/core/Models/interfaces/phoneCodes';
import { SharedService } from 'src/app/shared/services/shared.service';

@Component({
    selector: 'app-add-insurance',
    templateUrl: './add-insurance.component.html',
    styleUrls: ['./add-insurance.component.css'],
})
export class AddInsuranceComponent implements OnInit {
    @ViewChildren('focusedElement') focusedElement!: QueryList<any>;
    insuranceMngmtForm!: FormGroup;
    thirdPartyMngmtForm!: FormGroup;
    thirdPartyFormGroup!: FormGroup;

    companyDetails: FormGroup[] = [];
    selectedCopmanyDetails!: FormGroup;

    formSubmitted: boolean = false;
    isLoader: boolean = false;
    isEdit: boolean = false;
    payerEditDetails!: PayerDetails;
    public addOrEdit = 'Add New Payer';
    isUser: any = null;
    isUserTpa: any = null;
    public currencyList: Currency[] = [];
    public countryList: Country[] = [];
    public stateList: State[] = [];
    public stateListTpa: State[] = [];
    public regulatorList: Regulator[] = [];
    public cityList: City[] = [];
    public cityListTpa: City[] = [];
    public isThirdPartyComp: boolean = false;
    phoneCodes: PhoneCode[] = [];
    isValErr: boolean = false;

    @Input('editPayerId') editPayerId?: number | null;
    @Input('showDetailView') showDetailView?: boolean;
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    showSlider: boolean = false;
    tabActive: number = 0;
    thirdPartyFormArray!: FormArray;
    selectedItem?: FormGroup<any>;

    constructor(
        private formBuilder: FormBuilder,
        private provPayerApiService: ProvPayerApiService,
        private provPayerService: ProvPayerService,
        private router: Router,
        public datepipe: DatePipe,
        private toasterandloader: ToasterService,
        private sharedService: SharedService
    ) { }

    ngOnInit(): void {
        if (this.editPayerId != null) {
            this.isEdit = true;
            this.addOrEdit = 'Edit Payer';
            this.prepareForm();
            this.getMasterLists();
        } else {
            this.prepareForm();
            this.isLoader = false;
        }
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.showSlider = true;
        });
    }
    /*
     * @Desc   : To prepare the form and add validations
     * @Author : Athira
     */
    getMasterLists() {
        forkJoin([
            this.provPayerApiService.getCountryList(),
            this.provPayerApiService.getCurrencyList(),
            this.provPayerService.getEditPayerDetails(this.editPayerId),
            this.provPayerApiService.getPhoneCodes(),
        ]).subscribe({
            next: (responseList) => {
                this.countryList = responseList[0];
                this.currencyList = responseList[1];
                this.payerEditDetails = responseList[2].data[0];
                this.phoneCodes = responseList[3].data;
                this.phoneCodes.sort(function (a, b) {
                    var textA = a.countryName.toUpperCase();
                    var textB = b.countryName.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });
                if (this.payerEditDetails != null) {
                    this.setEditorFormValues();
                }
            },
        });
    }

    public payerCapIntegrationForm(): FormGroup {
        return this.formBuilder.group({
            payerCapIntegrationId: new FormControl(null),
            typeOfApi: new FormControl(null, Validators.required),
            endpoint: new FormControl(null, Validators.required),
            typeOfAuthorization: new FormControl(null),
            clientId: new FormControl(null),
            clinetSecret: new FormControl(null),
            redirectUri: new FormControl(null),
            token: new FormControl(null),
            method: new FormControl(null, Validators.required),
            requestPayloadSchema: new FormControl(null, Validators.required),
            activeToEnd: new FormControl(null, [
                Validators.required,
                CustomValidation.validityPattern,
                CustomValidation.checkEndDate,
                CustomValidation.checkStartDate,
            ]),
        })
    }

    prepareForm() {
        this.isLoader = true;

        (this.insuranceMngmtForm = this.formBuilder.group({
            companyDetailsForm: this.formBuilder.group({
                isThirdParty: new FormControl(null),
                companyName: new FormControl(null, Validators.required),
                payerCode: new FormControl(null, Validators.required),
                website: new FormControl(null, [
                    CustomValidation.validUrl,
                    Validators.required,
                ]),
                currency: new FormControl(null, Validators.required),
                associatedCountry: new FormControl(null, Validators.required),
                validity: new FormControl(null, [
                    Validators.required,
                    CustomValidation.validityPattern,
                    CustomValidation.checkEndDate,
                    CustomValidation.checkStartDate,
                ]),
                description: new FormControl('', Validators.maxLength(500)),
            }),
            addressForm: this.formBuilder.group({
                country: new FormControl(null, Validators.required),
                state: new FormControl(null, Validators.required),
                area: new FormControl(null, Validators.required),
                areaCode: new FormControl(null),
                geoCode: new FormControl(null),
                buildingName: new FormControl(null),
                streetName: new FormControl(null),
                stateList: new FormControl([]),
                cityList: new FormControl([]),
            }),
            contactForm: this.formBuilder.group({
                contactArray: this.formBuilder.array([
                    this.formBuilder.group({
                        firstName: new FormControl(null, Validators.required),
                        middleName: new FormControl(null),
                        lastName: new FormControl(null),
                        position: new FormControl(null, Validators.required),
                        contactNumber: new FormControl(null, [
                            CustomValidation.onlyNumber,
                            Validators.required,
                        ]),
                        contactEmail: new FormControl(null, [
                            CustomValidation.email,
                            Validators.required,
                        ]),
                        isUser: new FormControl(null),
                        showIsUser: new FormControl(true),
                        isChecked: new FormControl(false),
                        userName: new FormControl(null, [CustomValidation.email]),
                        password: new FormControl(null, [CustomValidation.PasswordRule]),
                        phoneCode: new FormControl(null, Validators.required),
                        isUserMailExist: new FormControl(false),
                    }),
                ]),
            }),
            regulatorForm: this.formBuilder.group({
                country: new FormControl(null, Validators.required),
                regulator: new FormControl(null, Validators.required),
                receiverId: new FormControl(null, Validators.required),
                payerId: new FormControl(null, Validators.required),
            }),
            credentialsForm: this.formBuilder.group({
                clientId: new FormControl(null),
                clientSecret: new FormControl(null),
                url: new FormControl(null, [CustomValidation.validUrl]),
                date: new FormControl(null),
            }),
            isCapShow: new FormControl(false),
        })),
            (
                this.insuranceMngmtForm?.controls?.['addressForm'] as FormGroup
            ).controls['country'].valueChanges.subscribe((value: any) => {
                if (value?.countryId) {
                    this.provPayerApiService
                        .getStateList(value.countryId)
                        .subscribe((res) => {
                            (
                                this.insuranceMngmtForm?.controls?.['addressForm'] as FormGroup
                            ).controls['stateList'].setValue(res.data);
                            (
                                this.insuranceMngmtForm?.controls?.['addressForm'] as FormGroup
                            ).patchValue({
                                state: this.insuranceMngmtForm?.controls?.[
                                    'addressForm'
                                ].value.stateList?.find(
                                    (el: any) => el.regionId == this.payerEditDetails?.region
                                ),
                            });
                        });
                }
            }),
            (
                this.insuranceMngmtForm?.controls?.['addressForm'] as FormGroup
            ).controls['state'].valueChanges.subscribe((value: any) => {
                if (value?.regionId) {
                    this.provPayerApiService
                        .getCityList(value.regionId)
                        .subscribe((res) => {
                            (
                                this.insuranceMngmtForm?.controls?.['addressForm'] as FormGroup
                            ).controls['cityList'].setValue(res.data);
                            this.insuranceMngmtForm?.controls?.['addressForm'].patchValue({
                                area: this.insuranceMngmtForm?.controls?.[
                                    'addressForm'
                                ].value.cityList?.find(
                                    (el: any) => el.locationId == this.payerEditDetails?.area
                                ),
                            });
                        });
                }
            }),
            (
                this.insuranceMngmtForm?.controls?.['addressForm'] as FormGroup
            ).controls['area'].valueChanges.subscribe((value: any) => {
                if (value) {
                    (
                        this.insuranceMngmtForm?.controls?.['addressForm'] as FormGroup
                    ).controls['areaCode'].setValue(value?.codes?.[0]?.postalCode);
                    (
                        this.insuranceMngmtForm?.controls?.['addressForm'] as FormGroup
                    ).controls['geoCode'].setValue(value?.codes?.[0]?.geoCode);
                }
            });
        this.insuranceMngmtForm?.controls['isCapShow'].valueChanges.subscribe((value: boolean) => {
            if (value) {
                if (!this.insuranceMngmtForm.getRawValue()?.payerCapIntegration) {
                    this.insuranceMngmtForm.addControl("payerCapIntegration", this.payerCapIntegrationForm())
                }
            } else {
                this.toasterandloader.alert.confirm(
                    {
                        text: "Are you sure you want to disable cap Integration? Any changes you have made will be lost. Press OK to continue, or Cancel to keep current change.",
                        type: 'warning',
                        hideCancelButton: false,
                        hideOkButton: false,
                        okText: 'OK',
                        cancelText: 'Cancel',
                        title: 'Warning!',
                    }
                ).then((val) => {
                    if (val) {
                        this.insuranceMngmtForm.removeControl("payerCapIntegration");
                    } else {
                        this.insuranceMngmtForm?.controls['isCapShow'].setValue(true);
                    }
                })
            }
        })
        this.isLoader = false;
    }
    thirdPartyPrepareForm() {
        this.thirdPartyMngmtForm = this.formBuilder.group({
            thirdPartyFormArray: this.formBuilder.array([
                this.createThirdPartFormArray(),
            ]),
        });
    }
    createThirdPartFormArray() {
        const thirdPartyCompGroup: any = this.formBuilder.group({
            thirdPartyId: this.formBuilder.group({
                payerId: new FormControl(null),
                tpaId: new FormControl(null),
            }),
            companyDetailsForm: this.formBuilder.group({
                isThirdParty: new FormControl(null),
                companyName: new FormControl(null, Validators.required),
                payerCode: new FormControl(null, Validators.required),
                website: new FormControl(null, [
                    CustomValidation.validUrl,
                    Validators.required,
                ]),
                currency: new FormControl(null, Validators.required),
                associatedCountry: new FormControl(null, Validators.required),
                validity: new FormControl(null, [
                    Validators.required,
                    CustomValidation.validityPattern,
                    CustomValidation.checkEndDate,
                    CustomValidation.checkStartDate,
                ]),
                description: new FormControl(null),
            }),
            addressForm: this.formBuilder.group({
                country: new FormControl(null, Validators.required),
                state: new FormControl(null, Validators.required),
                area: new FormControl(null, Validators.required),
                areaCode: new FormControl(null),
                geoCode: new FormControl(null),
                buildingName: new FormControl(null),
                streetName: new FormControl(null),
                stateList: new FormControl([]),
                cityList: new FormControl([]),
                areaDummy: new FormControl(null),
            }),
            contactForm: this.formBuilder.group({
                contactArray: this.formBuilder.array([
                    this.formBuilder.group({
                        firstName: new FormControl(null, Validators.required),
                        middleName: new FormControl(null),
                        lastName: new FormControl(null),
                        position: new FormControl(null, Validators.required),
                        contactNumber: new FormControl(null, [
                            CustomValidation.onlyNumber,
                            Validators.required,
                        ]),
                        contactEmail: new FormControl(null, [
                            CustomValidation.email,
                            Validators.required,
                        ]),
                        isUser: new FormControl(null),
                        showIsUser: new FormControl(true),
                        userName: new FormControl(null, [CustomValidation.email]),
                        password: new FormControl(null, [CustomValidation.PasswordRule]),
                        phoneCode: new FormControl(null, Validators.required),
                    }),
                ]),
            }),
            regulatorForm: this.formBuilder.group({
                country: new FormControl(null, Validators.required),
                regulator: new FormControl(null, Validators.required),
                receiverId: new FormControl(null, Validators.required),
                payerId: new FormControl(null, Validators.required),
                payerRegulatorId: new FormControl(null),
            }),
            credentialsForm: this.formBuilder.group({
                clientId: new FormControl(null),
                clientSecret: new FormControl(null),
                url: new FormControl(null, [CustomValidation.validUrl]),
                date: new FormControl(null),
            }),
            isCapShow: new FormControl(false),

        });
        thirdPartyCompGroup.controls['addressForm'].controls[
            'country'
        ].valueChanges.subscribe((value: any) => {
            if (value) {
                if (value.countryId) {
                    this.provPayerApiService
                        .getStateList(value.countryId)
                        .subscribe((res) => {
                            thirdPartyCompGroup.controls['addressForm'].controls[
                                'stateList'
                            ].setValue(res.data);
                            thirdPartyCompGroup.controls['addressForm'].patchValue({
                                state: thirdPartyCompGroup.controls[
                                    'addressForm'
                                ].value.stateList?.find(
                                    (el: any) =>
                                        el.regionId ==
                                        thirdPartyCompGroup.controls['addressForm'].value.state
                                ),
                            });
                        });
                }
            }
        });
        thirdPartyCompGroup.controls['addressForm'].controls[
            'state'
        ].valueChanges.subscribe((value: any) => {
            if (value && value.regionId) {
                this.provPayerApiService
                    .getCityList(value.regionId)
                    .subscribe((res) => {
                        thirdPartyCompGroup.controls['addressForm'].controls[
                            'cityList'
                        ].setValue(res.data);
                        thirdPartyCompGroup.controls['addressForm'].patchValue({
                            area: thirdPartyCompGroup.controls[
                                'addressForm'
                            ].value.cityList?.find(
                                (el: any) =>
                                    el.locationId ==
                                    thirdPartyCompGroup.controls['addressForm'].value.areaDummy
                            ),
                        });
                    });
            }
        }),
            thirdPartyCompGroup.controls['addressForm'].controls[
                'area'
            ].valueChanges.subscribe((value: any) => {
                if (value) {
                    thirdPartyCompGroup.controls['addressForm'].controls[
                        'areaCode'
                    ].setValue(value?.codes?.[0].postalCode);
                    thirdPartyCompGroup.controls['addressForm'].controls[
                        'geoCode'
                    ].setValue(value?.codes?.[0]?.geoCode);
                }
            });
        thirdPartyCompGroup.controls['isCapShow'].valueChanges.subscribe((value: any) => {
            if (value) {
                thirdPartyCompGroup.addControl("payerCapIntegration", this.payerCapIntegrationForm());
            } else {
                this.toasterandloader.alert.confirm(
                    {
                        text: "Are you sure you want to disable cap Integration? Any unsaved changes you have made will be lost. Press OK to continue, or Cancel to keep current change.",
                        type: 'warning',
                        hideCancelButton: false,
                        hideOkButton: false,
                        okText: 'OK',
                        cancelText: 'Cancel',
                        title: 'Warning!',
                    }
                ).then((val) => {
                    if (val) {
                        thirdPartyCompGroup.removeControl("payerCapIntegration");
                    } else {
                        thirdPartyCompGroup?.controls['isCapShow'].setValue(true);
                    }
                })
            }
        })
        return thirdPartyCompGroup;
    }
    setEditorFormValues() {
        this.isUser = this.payerEditDetails?.contactPerson?.[0]?.userId;
        this.insuranceMngmtForm?.controls?.['companyDetailsForm'].patchValue({
            associatedCountry: this.countryList.find(
                (el) => el.countryId === this.payerEditDetails?.assocCountry
            ),
            companyName: this.payerEditDetails?.payerName,
            payerCode: this.payerEditDetails?.payerCode,
            website: this.payerEditDetails?.website,
            description: this.payerEditDetails?.description,
            currency: this.currencyList?.find(
                (el) => el.currencyId === this.payerEditDetails?.currency
            ),
            validity: `${this.datepipe.transform(
                this.payerEditDetails?.validityStart,
                'dd/MM/YYYY'
            )} to ${this.datepipe.transform(
                this.payerEditDetails?.validityEnd,
                'dd/MM/YYYY'
            )}`,
        });
        this.insuranceMngmtForm?.controls?.['addressForm'].patchValue({
            country: this.countryList.find(
                (el) => el.countryId === this.payerEditDetails?.country
            ),
            // state: this.payerEditDetails?.region,
            area: this.payerEditDetails?.area,
            buildingName: this.payerEditDetails?.buildingName,
            streetName: this.payerEditDetails?.streetName,
            // password:this.payerEditDetails?.contactPerson[0]?.passWord
        });

        if (this.payerEditDetails?.contactPerson) {
            (
                this.insuranceMngmtForm?.controls?.['contactForm'].get(
                    'contactArray'
                ) as FormArray
            ).clear();
        }
        this.payerEditDetails?.contactPerson?.forEach((contact: any) => {
            (
                this.insuranceMngmtForm.controls?.['contactForm'].get(
                    'contactArray'
                ) as FormArray
            ).push(
                new FormGroup({
                    firstName: new FormControl(contact.contactPersonFname),
                    middleName: new FormControl(contact.contactPersonMname),
                    lastName: new FormControl(contact.contactPersonLname),
                    position: new FormControl(contact.roles ? contact.roles[0] : null),
                    contactNumber: new FormControl(contact.contactPhone),
                    contactEmail: new FormControl(contact.contactEmail),
                    isUser: new FormControl(contact.userId != null ? 1 : 0),
                    userName: new FormControl(contact.userName),
                    password: new FormControl(contact.password),
                    phoneCode: new FormControl(
                        this.phoneCodes.find(
                            (el: PhoneCode) =>
                                el.phoneCodeId == contact.countryPhoneCode[0]?.phoneCodeId
                        )
                    ),
                    showIsUser: new FormControl(contact.userId != null ? false : true),
                })
            );
        });
        this.insuranceMngmtForm?.controls?.['regulatorForm'].patchValue({
            country: this.payerEditDetails?.credentials?.[0]?.country,
            regulator: this.payerEditDetails?.credentials?.[0]?.regulatorId,
            receiverId: this.payerEditDetails?.credentials?.[0]?.receiverId,
            payerId: this.payerEditDetails?.credentials?.[0]?.payerRegReferenceId,
            payerRegulatorId: this.payerEditDetails?.credentials[0]?.payerRegulatorId,
        });

        this.insuranceMngmtForm?.controls?.['credentialsForm'].patchValue({
            clientId: this.payerEditDetails?.client_id,
            clientSecret: this.payerEditDetails?.client_secret,
            url: this.payerEditDetails?.url,
            date: `${this.datepipe.transform(
                this.payerEditDetails?.clientValidityStart,
                'dd/MM/YYYY'
            )} to ${this.datepipe.transform(
                this.payerEditDetails?.clientValidityEnd,
                'dd/MM/YYYY'
            )}`,
        });
        if (this.payerEditDetails?.payerCapIntegration?.length) {
            this.insuranceMngmtForm?.controls?.['isCapShow'].patchValue(true);
            this.insuranceMngmtForm?.controls?.['payerCapIntegration'].patchValue(this.payerEditDetails?.payerCapIntegration[0])
        }
        if (this.payerEditDetails.tpaPayers.length) {
            this.insuranceMngmtForm?.controls?.['companyDetailsForm'].patchValue({
                isThirdParty: true,
            });
            this.isThirdPartyCompany();
            this.setThirdPartyFormValues();
        }
    }

    setThirdPartyFormValues() {
        for (let i = 1; i < this.payerEditDetails.tpaPayers.length; i++) {
            this.onAddThirdParty();
        }
        this.payerEditDetails?.tpaPayers.forEach((item: any, index) => {
            this.tabActive = 0;
            this.isUserTpa = item.contactPerson[index]?.userId;
            this.companyDetails[index].controls?.['thirdPartyId'].patchValue({
                payerId: item?.payerId,
                tpaId: item?.tpaId,
            }),
                this.companyDetails[index].controls?.['companyDetailsForm'].patchValue({
                    associatedCountry: this.countryList.find(
                        (el) => el.countryId === item?.assocCountry
                    ),
                    companyName: item?.payerName,
                    payerCode: item?.payerCode,
                    website: item?.website,
                    description: item?.description,
                    currency: this.currencyList?.find(
                        (el) => el.currencyId === item?.currency
                    ),
                    validity: `${this.datepipe.transform(
                        item?.validityStart,
                        'dd/MM/YYYY'
                    )} to ${this.datepipe.transform(item?.validityEnd, 'dd/MM/YYYY')}`,
                }),
                this.companyDetails[index].controls?.['addressForm'].patchValue({
                    country: this.countryList.find(
                        (el) => el.countryId === item?.country
                    ),
                    state: item?.region,
                    areaDummy: item?.area,
                    areaCode: item?.areaCode,
                    geoCode: item?.geocode,
                    buildingName: item?.buildingName,
                    streetName: item?.streetName,
                });
            if (item?.contactPerson) {
                (
                    this.companyDetails[index]?.controls?.['contactForm'].get(
                        'contactArray'
                    ) as FormArray
                ).clear();
            }
            item?.contactPerson?.forEach((contact: any) => {
                (
                    this.companyDetails[index]?.controls?.['contactForm'].get(
                        'contactArray'
                    ) as FormArray
                ).push(
                    new FormGroup({
                        firstName: new FormControl(contact.contactPersonFname),
                        middleName: new FormControl(contact.contactPersonMname),
                        lastName: new FormControl(contact.contactPersonLname),
                        position: new FormControl(
                            contact.roles.length ? contact.roles[0] : null
                        ),
                        contactNumber: new FormControl(contact.contactPhone),
                        contactEmail: new FormControl(contact.contactEmail),
                        isUser: new FormControl(contact.userId != null ? 1 : 0),
                        userName: new FormControl(contact.userName),
                        password: new FormControl(contact.password),
                        phoneCode: new FormControl(
                            this.phoneCodes.find(
                                (el: PhoneCode) =>
                                    el.phoneCodeId == contact.countryPhoneCode[0]?.phoneCodeId
                            )
                        ),
                        showIsUser: new FormControl(contact.userId != null ? false : true),
                    })
                );
            });
            this.companyDetails[index]?.controls?.['regulatorForm'].patchValue({
                country: item?.credentials?.[0]?.country,
                regulator: item?.credentials?.[0]?.regulatorId,
                receiverId: item?.credentials?.[0]?.receiverId,
                payerId: item?.credentials?.[0]?.payerRegReferenceId,
                payerRegulatorId: item?.credentials?.[0]?.payerRegulatorId,
            });

            this.companyDetails[index]?.controls?.['credentialsForm'].patchValue({
                clientId: item?.client_id,
                clientSecret: item?.client_secret,
                url: item?.url,
            });
            if (item?.payerCapIntegration?.length) {
                this.companyDetails[index]?.controls?.['isCapShow'].patchValue(true);
                this.companyDetails[index]?.controls?.['payerCapIntegration'].patchValue(item?.payerCapIntegration[0])
            }

        });
    }

    saveForm() {
        this.formSubmitted = true;
        const tempForm = this.insuranceMngmtForm.controls?.['contactForm'].value.contactArray;
        tempForm.forEach((el: any, index: number) => {
            if (el?.isUser) {
                if (!el?.userName || !el?.password) {
                    this.insuranceMngmtForm?.setErrors({ invalid: true });
                    this.sharedService?.scrollToFirstInvalidControl();
                }
            }
        });
        if (this.insuranceMngmtForm.valid && this.isCompanyDetailsFormValid()) {
            this.toasterandloader.isLoaderEnable(true);
            // this.isLoader = true;
            let validity = this.insuranceMngmtForm.value.companyDetailsForm.validity;
            let valStart = validity?.substring(0, validity.indexOf(' '));
            let parts: any[] = validity?.split(' ');
            let valEnd = parts?.pop();
            let validityStart = valStart?.split('/').reverse().join('-');
            let validityEndDate = valEnd?.split('/').reverse().join('-');
            let companyDetails = this.insuranceMngmtForm.value.companyDetailsForm;
            let contactInfo = this.insuranceMngmtForm.value.contactForm;
            let crendentialInfo = this.insuranceMngmtForm.value.credentialsForm;
            let payerCapIntegration = this.insuranceMngmtForm.value?.payerCapIntegration;
            let regulatorInfo = this.insuranceMngmtForm.value.regulatorForm;
            let addressdata = this.insuranceMngmtForm.value.addressForm;
            const contactsTemp: any = [];


            const tempForm =
                this.insuranceMngmtForm.controls?.['contactForm'].value.contactArray;

            tempForm?.forEach((el: any) => {
                let temp = {
                    firstName: el.firstName ? el.firstName : null,
                    middleName: el.middleName ? el.middleName : null,
                    lastName: el.lastName ? el.lastName : null,
                    position: el.position ? el.position.id.toString() : null,
                    phoneCodeId: el.phoneCode ? el.phoneCode.phoneCodeId : null,
                    phone: el.contactNumber ? el.contactNumber : null,
                    email: el.contactEmail ? el.contactEmail.trim() : null,
                    isUser: el.isUser ? 1 : 0,
                    username: el.userName ? el.userName.trim() : null,
                    password: el.password ? el.password : null,
                };
                contactsTemp.push(temp);
            });
            let payload: any = {
                payerType: '1',
                companyName: companyDetails?.companyName
                    ? companyDetails?.companyName.trim()
                    : null,
                payerCode: companyDetails?.payerCode
                    ? companyDetails?.payerCode.trim()
                    : null,
                website: companyDetails?.website
                    ? companyDetails?.website.trim()
                    : null,
                currency: companyDetails?.currency?.currencyId,
                validityStart: validityStart ? validityStart : null,
                validityEnd: validityEndDate ? validityEndDate : null,
                assocCountry: companyDetails?.associatedCountry?.countryId,
                description: companyDetails?.description
                    ? companyDetails?.description
                    : null,
                area: addressdata?.area ? addressdata?.area.locationId : null,
                buildingName: addressdata?.buildingName
                    ? addressdata?.buildingName.trim()
                    : null,
                streetName: addressdata?.streetName
                    ? addressdata?.streetName.trim()
                    : null,
                areaCode: addressdata?.areaCode ? addressdata?.areaCode : null,
                geocode: addressdata?.geoCode ? addressdata?.geoCode : null,
                region: addressdata?.state ? addressdata?.state.regionId : null,
                addCountry: addressdata.country.countryId,
                isUser: contactInfo?.isUser ? 1 : 0,
                isActive: 1,
                parentId: 'DDK8396',
                licenseID: 'DDK8396',
                contactPerson: contactsTemp,
                credentials: [
                    {
                        country: addressdata.country.countryId,
                        regulatorId: regulatorInfo?.regulator,
                        receiverId: regulatorInfo?.receiverId,
                        payerRegReferenceId: regulatorInfo?.payerId,
                        payerRegulatorId:
                            this.payerEditDetails?.credentials[0].payerRegulatorId,
                    },
                ],
                tpaPayers: this.thirdPartyCompanyPayload(),
                payerCapIntegration: payerCapIntegration ? [payerCapIntegration] : []
            };


            if (this.editPayerId != null) {
                this.provPayerService
                    .saveEditPayerDetails(this.editPayerId, payload)
                    .subscribe({
                        next: (response) => {
                            if (response.status) {
                                this.isLoader = false;
                                this.toasterandloader.alert.toast({
                                    title: 'Success',
                                    type: 'success',
                                    message:
                                        'Payer Successfully Updated , Please collect your credentials',
                                });
                                this.closeBtn();
                            } else {
                            }
                            this.toasterandloader.isLoaderEnable(false);
                        },
                        error: (error) => {
                            this.toasterandloader.alert.toast({
                                title: 'Error',
                                type: 'error',
                                message: error.message,
                            });
                            this.toasterandloader.isLoaderEnable(false);
                            this.isLoader = false;
                        },
                    });
            } else {
                this.provPayerApiService.payerReg(payload).subscribe({
                    next: (response) => {
                        if (response.success) {
                            this.isLoader = false;
                            this.toasterandloader.alert.toast({
                                title: 'Success',
                                type: 'success',
                                message:
                                    'Payer Successfully Added , Please collect your credentials',
                            });
                            this.insuranceMngmtForm.controls['credentialsForm'].patchValue({
                                clientId: response?.data?.client_id,
                                clientSecret: response?.data?.client_secrete,
                            });
                        }
                        this.toasterandloader.isLoaderEnable(false);
                    },
                    error: (error) => {
                        this.toasterandloader.alert.toast({
                            title: 'Error',
                            type: 'error',
                            message: error.message,
                        });
                        this.toasterandloader.isLoaderEnable(false);
                        this.isLoader = false;
                    },
                });
            }
        } else {
            this.sharedService?.scrollToFirstInvalidControl();
        }
    }

    isCompanyDetailsFormValid() {
        let isValid = true;
        this.companyDetails.forEach((item) => {
            const tempForm = item.value.contactForm.contactArray;
            tempForm.forEach((el: any, index: number) => {
                if (el?.isUser) {
                    if (!el?.userName || !el?.password) {
                        isValid = false;
                        this.sharedService?.scrollToFirstInvalidControl();
                    }
                }
            });
        });
        if (this.isThirdPartyComp) {
            this.companyDetails.forEach((item) => {
                if (!item.valid) {
                    isValid = false;
                }
            });
        }
        return isValid;
    }
    thirdPartyCompanyPayload() {
        let companyTpaPayload: any[] = [];
        if (this.isThirdPartyComp) {
            this.companyDetails.forEach((item) => {
                let validity = item.value.companyDetailsForm.validity;
                let valStart = validity?.substring(0, validity.indexOf(' '));
                let parts: any[] = validity?.split(' ');
                let valEnd = parts?.pop();
                let validityStart = valStart?.split('/').reverse().join('-');
                let validityEndDate = valEnd?.split('/').reverse().join('-');
                let companyDetails = item.value.companyDetailsForm;
                let contactInfo = item.value.contactForm;
                let crendentialInfo = item.value.credentialsForm;
                let regulatorInfo = item.value.regulatorForm;
                let addressdata = item.value.addressForm;
                const contactsTemporary: any = [];
                const tempForm = item.value.contactForm.contactArray;
                let payerCapIntegration = item.value?.payerCapIntegration;


                tempForm.forEach((el: any) => {
                    let temp = {
                        firstName: el.firstName ? el.firstName : null,

                        middleName: el.middleName ? el.middleName : null,

                        lastName: el.lastName ? el.lastName : null,

                        position: el.position ? el.position : null,

                        phoneCodeId: el.phoneCode ? el.phoneCode.phoneCodeId : null,

                        phone: el.contactNumber ? el.contactNumber : null,

                        email: el.contactEmail ? el.contactEmail.trim() : null,

                        isUser: el.userName && el.password ? 1 : 0,

                        username: el.userName ? el.userName.trim() : null,

                        password: el.password ? el.password : null,
                    };
                    contactsTemporary.push(temp);
                });
                let payload: any = {
                    payerType: '1',
                    companyName: companyDetails?.companyName
                        ? companyDetails?.companyName.trim()
                        : null,
                    payerCode: companyDetails?.payerCode
                        ? companyDetails?.payerCode.trim()
                        : null,
                    website: companyDetails?.website
                        ? companyDetails?.website.trim()
                        : null,
                    currency: companyDetails?.currency?.currencyId,
                    validityStart: validityStart ? validityStart : null,
                    validityEnd: validityEndDate ? validityEndDate : null,
                    assocCountry: companyDetails?.associatedCountry?.countryId,
                    description: companyDetails?.description
                        ? companyDetails?.description
                        : null,
                    area: addressdata?.area ? addressdata?.area.locationId : null,
                    buildingName: addressdata?.buildingName
                        ? addressdata?.buildingName.trim()
                        : null,
                    streetName: addressdata?.streetName
                        ? addressdata?.streetName.trim()
                        : null,
                    areaCode: addressdata?.areaCode ? addressdata?.areaCode : null,
                    geocode: addressdata?.geoCode ? addressdata?.geoCode : null,
                    region: addressdata?.state ? addressdata?.state.regionId : null,
                    addCountry: addressdata.country.countryId,
                    isUser: contactInfo.isUser ? contactInfo.isUser : 0,
                    isActive: 1,
                    parentId: 'DDK8396',
                    licenseID: 'DDK8396',
                    payerId: item.value.thirdPartyId.payerId
                        ? item.value.thirdPartyId.payerId
                        : null,
                    tpaId: item.value.thirdPartyId.tpaId
                        ? item.value.thirdPartyId.tpaId
                        : null,
                    contactPerson: contactsTemporary,
                    credentials: [
                        {
                            country: addressdata.country.countryId,
                            regulatorId: regulatorInfo?.regulator,
                            receiverId: regulatorInfo?.receiverId,
                            payerRegReferenceId: regulatorInfo?.payerId,
                            payerRegulatorId: regulatorInfo?.payerRegulatorId
                                ? regulatorInfo?.payerRegulatorId
                                : null,
                        },
                    ],
                    payerCapIntegration: payerCapIntegration ? [payerCapIntegration] : []
                };
                companyTpaPayload.push(payload);
            });
            return companyTpaPayload;
        } else {
            return [];
        }
    }

    closeBtn() {
        this.editPayerId = null;
        this.close.emit(false);
    }

    isThirdPartyCompany() {
        this.isThirdPartyComp = !this.isThirdPartyComp;
        if (!this.companyDetails.length) {
            this.thirdPartyPrepareForm();
            this.companyDetails.push(this.createThirdPartFormArray());
        }
        // this.isScrollIntoViewNeeded();
    }
    getFormData() {
        return this.companyDetails[this.tabActive];
    }

    onAddThirdParty() {
        this.companyDetails.push(this.createThirdPartFormArray());
        this.tabActive = this.companyDetails.length - 1;
        // this.isScrollIntoViewNeeded();
    }

    isScrollIntoViewNeeded() {
        if (!this.payerEditDetails?.tpaPayers.length) {
            setTimeout(() => {
                this.focusedElement.last?.nativeElement.scrollIntoView();
            }, 100);
        }
    }

    focusNextTicket() {
        if (this.companyDetails.length > this.tabActive + 1) {
            this.selectItem(this.companyDetails[this.tabActive + 1]);
            this.focusedElement
                .get(this.tabActive + 1)
                ?.nativeElement.scrollIntoView();
        }
    }
    focusPreviousTicket() {
        if (this.tabActive - 1 >= 0) {
            this.selectItem(this.companyDetails[this.tabActive - 1]);
            this.focusedElement
                .get(this.tabActive - 1)
                ?.nativeElement.scrollIntoView();
        }
    }

    public selectItem(item: FormGroup) {
        this.selectedItem = item;
        this.tabActive = this.companyDetails.findIndex(
            (item) => item == this.selectedItem
        );
    }

    switchTab(i: number) {
        this.tabActive = i;
    }
    shift(left: boolean, right: boolean) {
        if (left && !right && this.tabActive != 0) {
            this.tabActive--;
        } else {
            if (this.tabActive != this.companyDetails.length - 1) {
                this.tabActive++;
            }
        }
    }
    closeThirdParty(i: number) {
        this.companyDetails.splice(i, 1);
        if (!this.companyDetails?.length) {
            this.isThirdPartyComp = false;
            this.provPayerService.isThirdParyOpened$.next(false);
        } else if (i == this.companyDetails.length) {
            this.tabActive = i - 1;
        } else {
            this.tabActive = i;
        }
    }
}
